import React, {Component} from 'react';
import './AddMap.css';
import {Redirect} from 'react-router-dom';

//TODO Add delete map api

export default class AddMap extends Component {
    state = {
        mapName: '',
        redirectBool: false
    };
    onInputChange = (e) => {
        this.setState({mapName: e.target.value});
    };

    redirectToMapList = () => {
        if (this.state.redirectBool) {
            return (<Redirect to='/map-list'/>);
        }
    };

    componentDidMount() {
        document.title = 'Add Map';
    }

    addMap = () => {
        fetch(`https://iotjokebase.herokuapp.com/addmap?uuid=${localStorage.getItem('uuid')}&mapname=${this.state.mapName}`, {method: 'POST'}).then(resp => {
            resp.json().then(jsnRsp => {
                // console.log(jsnRsp);
                if (jsnRsp.added) {
                    alert('Map Added');
                    this.setState({redirectBool: true});
                } else {
                    alert('Map name already used by another user');
                    this.setState({redirectBool: true});
                }
            }).catch(jsnErr => {
                console.log('JSON Error : ' + jsnErr.message);
            });
        }).catch(err => {
            console.log('Fetch Error : ' + err.message);
        });
    };

    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined' || localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    render() {
        return (<div>
            {this.redirectToLogin()}
            {this.redirectToMapList()}
            <input type='text' onChange={this.onInputChange}/>
            <button onClick={this.addMap}>Add</button>
        </div>);
    }
}
